module.exports = __webpack_public_path__ + "static/media/sun_moon.f393f7eb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tangible/sun_moon.mp3
// module id = 744
// module chunks = 0